import { render, staticRenderFns } from "./ItemWithRemoveButton.vue?vue&type=template&id=64ffc564&scoped=true&"
import script from "./ItemWithRemoveButton.vue?vue&type=script&lang=js&"
export * from "./ItemWithRemoveButton.vue?vue&type=script&lang=js&"
import style0 from "./ItemWithRemoveButton.vue?vue&type=style&index=0&id=64ffc564&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ffc564",
  null
  
)

export default component.exports